import { nextTick, onMounted, ref } from "vue";
import { fetchRss, type RssItem } from "./useRssFeed";

export const useNews = () => {
  const articleDataArray = ref<RssItem[]>([]);
  const loading = ref(false);
  const error = ref<string | null>(null);

  const load = async () => {
    loading.value = true;
    error.value = null;
    try {
      articleDataArray.value = await fetchRss(
        "https://note.bot-express.com/rss",
        20,
      );
      await nextTick();
      document.documentElement.classList.add("is-loaded");
      window.dispatchEvent(new Event("scroll"));
    } catch (e) {
      error.value = e instanceof Error ? e.message : "failed to load rss";
      await nextTick();
      document.documentElement.classList.add("is-loaded");
    } finally {
      loading.value = false;
    }
  };

  onMounted(load);

  return {
    articleDataArray,
    loading,
    error,
    load,
  };
};
